module.exports =
  '_RECOMMEND':
    'USE_PC': 'We recommend that you use the PC site or the app for score entry / information editing.'



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/modal/i18n/en.coffee